import { Suspense, lazy } from 'react';

type RichTextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  autofocus?: boolean;
  mentionSuggestions?: string[];
};

const SynchronousRichTextEditor = lazy(
  () => import('./RichTextEditor/SynchronousRichTextEditor')
);

export const RichTextEditor = ({ ...props }: RichTextEditorProps) => {
  return (
    <Suspense fallback={<></>}>
      <SynchronousRichTextEditor {...props}></SynchronousRichTextEditor>
    </Suspense>
  );
};
